<script lang="ts">
    import Popover from "../lib/components/Popover.svelte";
    import Range from "../lib/components/Range.svelte";
    import { displaySettings, resetDisplay } from "../lib/display";

    let s = $displaySettings;
    displaySettings.subscribe((v) => (s = v));

    function update() {
        displaySettings.set({ ...s });
    }
</script>

<Popover align="end">
    <button
        slot="trigger"
        type="button"
        title="Настройки отображения"
        class="size-8 inline-flex items-center justify-center rounded-md text-[var(--muted-foreground)] hover:bg-[var(--accent)] hover:text-[var(--accent-foreground)] transition-colors cursor-pointer"
    >
        <!-- sliders icon -->
        <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        >
            <line x1="4" y1="21" x2="4" y2="14" />
            <line x1="4" y1="10" x2="4" y2="3" />
            <line x1="12" y1="21" x2="12" y2="12" />
            <line x1="12" y1="8" x2="12" y2="3" />
            <line x1="20" y1="21" x2="20" y2="16" />
            <line x1="20" y1="12" x2="20" y2="3" />
            <line x1="1" y1="14" x2="7" y2="14" />
            <line x1="9" y1="8" x2="15" y2="8" />
            <line x1="17" y1="16" x2="23" y2="16" />
        </svg>
    </button>

    <div class="flex items-center justify-between mb-3">
        <div class="text-sm font-semibold">Отображение</div>
        <button
            type="button"
            on:click={resetDisplay}
            class="inline-flex items-center gap-1 text-xs text-[var(--muted-foreground)] hover:text-[var(--foreground)] transition-colors cursor-pointer"
        >
            <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                ><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" /><path
                    d="M3 3v5h5"
                /></svg
            >
            сброс
        </button>
    </div>

    <div class="flex flex-col gap-3">
        <div>
            <div class="flex items-center justify-between mb-1.5">
                <div
                    class="flex items-center gap-1.5 text-xs text-[var(--muted-foreground)]"
                >
                    <svg
                        width="13"
                        height="13"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        ><polyline points="4 7 4 4 20 4 20 7" /><line
                            x1="9"
                            y1="20"
                            x2="15"
                            y2="20"
                        /><line x1="12" y1="4" x2="12" y2="20" /></svg
                    >
                    Размер шрифта
                </div>
                <div class="text-xs font-mono">{s.fontSize}px</div>
            </div>
            <Range
                min={12}
                max={20}
                step={1}
                bind:value={s.fontSize}
                on:input={update}
            />
        </div>

        <div>
            <div class="flex items-center justify-between mb-1.5">
                <div
                    class="flex items-center gap-1.5 text-xs text-[var(--muted-foreground)]"
                >
                    <svg
                        width="13"
                        height="13"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        ><circle cx="12" cy="12" r="4" /><path
                            d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"
                        /></svg
                    >
                    Яркость текста
                </div>
                <div class="text-xs font-mono">
                    {s.brightness > 0 ? "+" : ""}{s.brightness}%
                </div>
            </div>
            <Range
                min={-50}
                max={50}
                step={5}
                bind:value={s.brightness}
                on:input={update}
            />
        </div>

        <div class="text-[11px] text-[var(--muted-foreground)] leading-snug">
            Яркость влияет на приглушённый текст (подписи, подсказки, списки).
        </div>
    </div>
</Popover>
